export default "__VITE_ASSET__D3yLko9u__"